import { useState, useEffect } from "react";

export const useVerificationTimer = (userId) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [canSend, setCanSend] = useState(true);

  // Check localStorage on mount and userId change
  useEffect(() => {
    if (!userId) return;

    const stored = localStorage.getItem(`verification_timer_${userId}`);
    if (stored) {
      try {
        const { cooldownEnd } = JSON.parse(stored);
        const now = Date.now();
        if (now < cooldownEnd) {
          const remaining = cooldownEnd - now;
          setTimeLeft(remaining);
          setCanSend(false);
        } else {
          localStorage.removeItem(`verification_timer_${userId}`);
          setTimeLeft(0);
          setCanSend(true);
        }
      } catch (e) {
        console.error("Failed to parse timer from localStorage:", e);
        localStorage.removeItem(`verification_timer_${userId}`);
        setTimeLeft(0);
        setCanSend(true);
      }
    } else {
      setTimeLeft(0);
      setCanSend(true);
    }
  }, [userId]);

  const formatTime = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const startCooldown = (cooldownTime = 180000) => {
    if (!userId) return;

    const cooldownEnd = Date.now() + cooldownTime;
    try {
      localStorage.setItem(
        `verification_timer_${userId}`,
        JSON.stringify({
          cooldownEnd,
        })
      );

      setTimeLeft(cooldownTime);
      setCanSend(false);
    } catch (e) {
      console.error("Failed to save timer to localStorage:", e);
    }
  };

  // Countdown timer
  useEffect(() => {
    if (timeLeft <= 0) {
      setCanSend(true);
      return;
    }

    setCanSend(false);
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1000;
        if (newTime <= 0) {
          setCanSend(true);
          if (userId) {
            localStorage.removeItem(`verification_timer_${userId}`);
          }
          return 0;
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, userId]);

  return {
    timeLeft,
    canSend,
    formatTime,
    startCooldown,
  };
};
